import { useEffect } from "react";
import { authService } from "../../services/authService";
import { useNavigate } from "react-router-dom";
import useCustomParams from "../../hooks/params/useCustomParams";
import Loader from "../../components/ui/Loader";
import useToken from "../../hooks/auth/useToken";
import { User } from "../../types/features/User";
import useAuth from "../../hooks/auth/useAuth";

export default function RedirectPage() {
  const { token } = useCustomParams();
  const navigate = useNavigate();
  const { saveToken } = useToken();
  const { setUser } = useAuth();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        if (!token) {
          navigate("/denied");
          return;
        }

        const currentUser: User | null = await authService.getCurrentUser(token);
        console.log(currentUser);

        if (currentUser) {
          const { role } = currentUser;
          if (role === "ADMIN") {
            saveToken(token);
            setUser(currentUser);
            navigate("/support/dashboard");
          } else {
            // Rediriger vers denied pour les non-admin
            navigate("/denied");
          }
        } else {
          navigate("/denied");
        }
      } catch (err) {
        console.error("Erreur lors de la récupération de l'utilisateur:", err);
        navigate("/denied");
      }
    };

    fetchUser();
  }, [token, navigate, saveToken]);

  return <Loader />;
}
